var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-inverse navbar-fixed-top style"},[_c('div',{staticClass:"container-fluid col-sm-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"navbar-header"},[_c('img',{attrs:{"src":_vm.img1,"height":"55","width":"auto"}})]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-right hidden-sm-and-down"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0a5d0ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/TopBar.vue
// module id = null
// module chunks = 